export const ALL = "All";

export const ITEMS_TO_SHOW = 1;
export const SLIDE_SPEED = 500;

export const PREV = "prev";
export const NEXT = "next";
export const ACTIVE = "active";
